import * as React from 'react'
import * as Namecheap from '../service/namecheap'


export default class AboutModal extends React.PureComponent<{
  names: string[]
  onRemove: (name: string) => void
  onClose: () => void
}> {

  onBuy(name: string) {
    const url = Namecheap.affiliateLink(name)
    window.open(url, '_blank')
  }

  render() {
    const {
      names,
      onClose,
      onRemove
    } = this.props

    return (
      <div className="modal saved-modal">
        <div className="modal-content">

          <h1>Saved</h1>

          {names.length == 0 &&
            <p>You can save names for later.<br/>Tap on any name and then on <strong>Save</strong>.</p>
          }

          <div className="saved-names">
            {names.sort().map(name =>
              <div className="saved-name" key={name}>
                <div>{name}</div>
                <div>
                  <button className="saved-remove" onClick={() => onRemove(name)}>REMOVE</button>
                  <button className="saved-buy" onClick={() => this.onBuy(name)}>BUY .COM</button>
                </div>
              </div>
            )}
          </div>

          <button className="modal-close" onClick={onClose}>&times;</button>

        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/comp/saved-modal.tsx